(function ($) {
    function initCampanhaAuditoriasForm() {
        const $produtoInput = $("#produto_search_input");
        const $produtoHidden = $('input[name="produto_interesse_id"]');
        const $produtoResults = $("#produto_results_dropdown");
        const $produtoMenu = $("#produto_results_menu");
        const $temInteresse = $("#tem_interesse");
        const $temHistorico = $("#tem_historico");
        const $diasUltimoAtendimento = $("#dias_ultimo_atendimento");
        const $temTags = $("#tem_tags");
        const searchUrl = $produtoInput.data("produto-search-url");
        let searchTimeout;

        if (!$produtoInput.length) {
            return;
        }

        $temInteresse.on("change.campanhaAuditorias", function () {
            const isSelected = $(this).val() === "1";

            if (isSelected) {
                $produtoInput.prop("disabled", false).removeClass("disabled");
            } else {
                $produtoInput.prop("disabled", true).addClass("disabled");
                $produtoInput.val("");
                $produtoHidden.val("");
                $produtoResults.hide();
            }
        });

        $temHistorico.on("change.campanhaAuditorias", function () {
            const isSelected = $(this).val() === "1";
            $diasUltimoAtendimento.prop("disabled", !isSelected);
        });

        $temTags.on("change.campanhaAuditorias", function () {
            const isSelected = $(this).val() === "1";
            const $tagsSelects = $(".tags-select .ui.dropdown");

            if (isSelected) {
                $tagsSelects.removeClass("disabled");
            } else {
                $tagsSelects.addClass("disabled");
                if (typeof $tagsSelects.dropdown === "function") {
                    $tagsSelects.dropdown("clear");
                }
            }
        });

        if (typeof $.fn.dropdown === "function") {
            $(".ui.dropdown").dropdown();
        }

        $produtoInput.on("input.campanhaAuditorias", function () {
            const query = $(this).val().trim();

            clearTimeout(searchTimeout);

            if (query.length >= 2 && searchUrl) {
                searchTimeout = setTimeout(function () {
                    $.ajax({
                        url: searchUrl,
                        method: "GET",
                        data: { search: query },
                        success: function (response) {
                            $produtoMenu.empty();

                            if (response.data && response.data.length > 0) {
                                response.data.forEach(function (item) {
                                    $produtoMenu.append(
                                        '<div class="item" data-id="' +
                                            item.id +
                                            '" data-text="' +
                                            item.text +
                                            '">' +
                                            item.text +
                                            "</div>"
                                    );
                                });
                                $produtoResults.show();
                            } else {
                                $produtoMenu.append(
                                    '<div class="message">Nenhum produto encontrado</div>'
                                );
                                $produtoResults.show();
                            }
                        },
                        error: function () {
                            $produtoMenu.html(
                                '<div class="message">Erro ao buscar produtos</div>'
                            );
                            $produtoResults.show();
                        },
                    });
                }, 300);
            } else {
                $produtoResults.hide();
            }
        });

        $produtoMenu.on("click.campanhaAuditorias", ".item", function () {
            const productId = $(this).data("id");
            const productText = $(this).data("text");

            if (productId) {
                $produtoHidden.val(productId);
                $produtoInput.val(productText);
            }

            $produtoResults.hide();
        });

        $(document).on("click.campanhaAuditorias", function (event) {
            if (!$(event.target).closest(".produto-interesse").length) {
                $produtoResults.hide();
            }
        });

        $produtoInput.on("blur.campanhaAuditorias", function () {
            setTimeout(function () {
                if ($produtoInput.val().trim() === "") {
                    $produtoHidden.val("");
                }
            }, 200);
        });

        $temInteresse.trigger("change");
        $temHistorico.trigger("change");
        $temTags.trigger("change");
    }

    $(function () {
        initCampanhaAuditoriasForm();
    });
})(jQuery);
